/** Date-only picker (calendar popup), themed to the dark palette.
 *
 * Drop-in for a native <input type="date">: `value` / `onChange` speak
 * "YYYY-MM-DD" strings so existing form state needs no change.
 */
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import { MuiPickersProvider } from "./MuiPickers";

type Props = {
  /** "YYYY-MM-DD", or "" when unset. */
  value: string;
  onChange: (date: string) => void;
  minDate?: string;
  disabled?: boolean;
  ariaLabel?: string;
};

export function MuiDatePicker({
  value,
  onChange,
  minDate,
  disabled,
  ariaLabel,
}: Props) {
  return (
    <MuiPickersProvider>
      <DatePicker
        value={value ? dayjs(value) : null}
        minDate={minDate ? dayjs(minDate) : undefined}
        disabled={disabled}
        onChange={(d) =>
          onChange(d && d.isValid() ? d.format("YYYY-MM-DD") : "")
        }
        slotProps={{
          textField: {
            size: "small",
            fullWidth: true,
            "aria-label": ariaLabel,
          },
        }}
      />
    </MuiPickersProvider>
  );
}
